<template>
  <div :key="$route.fullPath" class="room-hello">
    <header-title v-bind:title_img_src="title_img" />
    <nav-bar></nav-bar>
    <div v-if="user">
      {{user.twitch_name}}'s Room <button class="btn-copy" @click="copyToClipboard">Copy Share Link</button>
      <div class="upper-right-area">
        <!-- <button v-if="editable" @click="saveRoom">SAVE</button> -->
        <button v-if="editable" class="btn-save" @click="saveRoom">SAVE</button>
        <div v-if="editable && isMobileBrowser">Mobile ALPHA CONTROLS: Double tap an item to select it. Tap-drag to edit.</div>
      </div>
      <span v-if="notification">- {{notification}}</span> 
      <div id="room-container"></div>
      <div style="font-size:10px;">ROOMS are beta, there will be bugs! Press spacebar to change modes. Edit mode - Use mouse to click and orbit, mousewheel to zoom. FPS mode - Use most to click and look, wsad to move.</div>
      <div v-if="this.showBrowser">Your Inventory</div>
      <InventoryBrowser v-if="this.showBrowser">
        <template v-slot:actions="{ lootItem, ownedLootItem }">
          <span v-if="isRoomItem(lootItem)">
            <button v-if="canPlaceInRoom(lootItem.id, ownedLootItem)" class="btn-save" style="font-size:12px;"  @click="addToRoom(ownedLootItem, lootItem)">ADD TO ROOM</button>
            <button v-if="numberInRoom(lootItem.id) > 0" class="btn-save" style="font-size:12px;"  @click="removeFromRoom(ownedLootItem, lootItem)">REMOVE FROM ROOM</button>
          </span>
          <span v-if="isWallBaseItem(lootItem)">
            <button :class="isWallBaseItem(lootItem, 'back') ? 'wall-base-add' : 'wall-base-remove'" style="font-size:12px;"  @click="setWallBase('back', ownedLootItem, lootItem)">B</button>
            <button :class="isWallBaseItem(lootItem, 'front') ? 'wall-base-add' : 'wall-base-remove'" style="font-size:12px;"  @click="setWallBase('front', ownedLootItem, lootItem)">F</button>
            <button :class="isWallBaseItem(lootItem, 'left') ? 'wall-base-add' : 'wall-base-remove'" style="font-size:12px;"  @click="setWallBase('left', ownedLootItem, lootItem)">L</button>
            <button :class="isWallBaseItem(lootItem, 'right') ? 'wall-base-add' : 'wall-base-remove'" style="font-size:12px;"  @click="setWallBase('right', ownedLootItem, lootItem)">R</button>
          </span>
          <span v-if="isFloorBaseItem(lootItem)">
              <button v-if="isCurrentFloorBaseItem(lootItem)" class="wall-base-remove" style="width:80%; font-size:12px;"  @click="setFloorBase(ownedLootItem, lootItem)">REMOVE FLOOR</button>
              <button v-else class="wall-base-add" style="width:80%;font-size:12px;"  @click="setFloorBase(ownedLootItem, lootItem)">SET FLOOR</button>
          </span>
        </template>
        <template v-slot:numberInRoom="{ lootItem }">
          {{numberInRoom(lootItem.id)}}
        </template>
      </InventoryBrowser>
    </div>
    <div v-else-if="noCurrentUser">
      <login-btn buttonClass="btn-enabled" style="font-size: 40px; padding: 8px;">Login to edit your room!</login-btn>
    </div>
  </div>
</template>

<script>
import User from './User'
import InventoryBrowser from './InventoryBrowser'
import Vue from 'vue'
import { mapState } from 'vuex'
import axios from 'axios'
import { isMobile } from 'mobile-device-detect'

let scriptLoaded = false
let scriptFinished = false

/* global SwiftorRooms */

export default {
  name: 'rooms',
  props: ['twitch_name'],
  components: {
    User,
    InventoryBrowser
  },
  data () {
    return {
      title_img: 'swiftorland-title.svg',
      roomDisplayed: false,
      room: undefined,
      roomManager: undefined,
      roomObjectMap: {},
      wallParams: {},
      floorParams: {},
      notification: undefined
    }
  },
  computed: Object.assign(mapState([
    'currentUser', 'noCurrentUser'
  ]), {
    isMobileBrowser () {
      return isMobile
    },
    user () {
      if (this.twitch_name) {
        return this.$store.state.users[this.$store.state.userIdByTwitchNames[this.twitch_name]]
      } else {
        return this.currentUser
      }
    },
    user_id () {
      return this.$store.state.userIdByTwitchNames[this.twitch_name]
    },
    editable () {
      return this.user && this.currentUser && this.user.id === this.currentUser.id
    },
    showBrowser () {
      return this.editable && this.roomManager
    },
    showLogin () {
      return !this.user && !this.twitch_name
    }
  }),
  watch: {
    '$route' () {
      this.roomDisplayed = false
    },
    user (nv, ov) {
      this.displayRoom()
    },
    twitch_name (nv, ov) {
      if (this.twitch_name) {
        this.$store.dispatch('fetchUserByTwitchName', this.twitch_name)
      }
    },
    '$route.path' (to, from) {
    }
  },
  updated () {
  },
  destroyed () {
  },
  mounted () {
    if (this.user) {
      this.displayRoom()
    }
  },
  created: function () {
    if (!scriptLoaded) {
      if (this.twitch_name) {
        this.$store.dispatch('fetchUserByTwitchName', this.twitch_name)
      }

      let roomScript = document.createElement('script')
      roomScript.setAttribute('src', Vue.config.ROOM_JS_URL)
      document.head.appendChild(roomScript)

      roomScript.onload = () => {
        scriptFinished = true

        this.displayRoom()
      }

      scriptLoaded = roomScript
    }

    this.roomScript = scriptLoaded
  },
  methods: {
    nextRoom () {
      this.twitch_name = 'crash2burn'
    },
    copyToClipboard () {
      const el = document.createElement('textarea')
      console.log(this.user)
      el.value = `https://swiftorland.com/#/rooms/${encodeURIComponent(this.user.twitch_name)}`
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      this.notify(`https://swiftorland.com/#/rooms/${this.user.twitch_name} copied to clipboard!`)
    },
    isRoomItem (lootItem) {
      return lootItem.meta.objectType === '2d' || lootItem.meta.objectType === '3d' || lootItem.meta.objectType === 'wall'
    },
    isWallBaseItem (lootItem, position = undefined) {
      let res = lootItem.meta.objectType === 'wallBase'
      if (position) { res = res && (!this.wallParams[position] || this.wallParams[position].loot_item_id !== lootItem.id) }
      return res
    },
    isFloorBaseItem (lootItem) {
      return lootItem.meta.objectType === 'floorBase'
    },
    isCurrentFloorBaseItem (lootItem) {
      return lootItem.id === this.floorParams.loot_item_id
    },
    canPlaceInRoom (lootItemId, ownedLootItem) {
      let nir = this.numberInRoom(lootItemId)
      return nir < ownedLootItem.quantity && nir <= 10
    },
    numberInRoom (lootItemId) {
      if (this.roomManager && this.roomManager.room) {
        return this.roomObjectMap[lootItemId] ? this.roomObjectMap[lootItemId].length : 0
      } else {
        return 66
      }
    },
    async saveRoom () {
      let response = await axios.post(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/rooms/${this.currentUser.id.toString()}`, {
        'items': this.roomParams().items,
        'walls': this.wallParams,
        'floor': this.floorParams
      }, {withCredentials: true})
      if (response.data.room) {
        this.notify('Room Saved.')
      } else {
        this.notify('ERROR SAVING.')
      }
    },
    notify (text) {
      this.notification = text
      setTimeout(() => {
        this.notification = undefined
      }, 5000)
    },
    roomParams () {
      let items = []

      Object.keys(this.roomObjectMap).forEach(lootItemId => {
        this.roomObjectMap[lootItemId].forEach(roomObject => {
          items.push({
            loot_item_id: lootItemId,
            meta: roomObject.toMeta()
          })
        })
      })
      return {
        items: items
      }
    },
    setWallBase (position, ownedLootItem, lootItem) {
      if (this.wallParams[position] && this.wallParams[position].loot_item_id === lootItem.id) {
        return this.removeWallBase(position)
      }
      this.roomManager.room.createWall(position, lootItem.meta)
      Vue.set(this.wallParams, position, {loot_item_id: lootItem.id})
    },
    removeWallBase (position) {
      this.roomManager.room.createWall(position)
      Vue.set(this.wallParams, position, undefined)
    },
    setFloorBase (ownedLootItem, lootItem) {
      if (this.floorParams && this.floorParams.loot_item_id === lootItem.id) {
        return this.removeFloorBase()
      }
      console.log('CREATEING FLOOR', lootItem.meta)
      this.roomManager.room.createFloor(lootItem.meta)
      Vue.set(this.floorParams, 'loot_item_id', lootItem.id)
    },
    removeFloorBase () {
      this.roomManager.room.createFloor()
      this.floorParams = {}
    },
    addToRoom (ownedLootItem, lootItem) {
      let roomObject = this.roomManager.room.addRoomObject(Object.assign({}, ownedLootItem.meta, lootItem.meta))
      let arr = this.roomObjectMap[lootItem.id] || []
      // this.roomObjectMap[lootItem.id] = this.roomObjectMap[lootItem.id] || []
      arr.push(roomObject)
      Vue.set(this.roomObjectMap, lootItem.id, arr)
      return roomObject
    },
    removeFromRoom (ownedLootItem, lootItem) {
      let roomObject = this.roomObjectMap[lootItem.id][0]
      let arr = this.roomObjectMap[lootItem.id] || []
      Vue.set(this.roomObjectMap, lootItem.id, arr.splice(1))
      this.roomManager.room.removeRoomObject(roomObject.uuid)
    },
    roomItemToRoomObject (roomItem) {
      /*
      {
        loot_item_id: "",
        meta: "",
        loot_item: {}
      }
      */
      return Object.assign({}, roomItem.meta, roomItem.loot_item.meta)
    },
    async displayRoom () {
      if (!scriptFinished || !this.user || this.roomDisplayed === this.user.id) { // } || this.roomDisplayed) { // } || !scriptFinished || this.roomDisplayed || !this.roomScript) {
        return
      } else {

      }

      const response = await axios.get(`${Vue.config.CURRENCY_SERVICE_BASE_URL}/rooms/${this.user.id}`, { withCredentials: true })
      if (this.roomDisplayed !== this.user.id && response && response.data.room) {
        this.room = undefined
        this.roomManager = undefined
        this.roomObjectMap = {}

        this.room = response.data.room

        this.roomManager = new SwiftorRooms.RoomManager(Object.assign({
          container: document.getElementById('room-container'),
          assetBaseUrl: Vue.config.ITEM_ASSET_BASE_URL,
          editable: this.editable,
          isMobile: isMobile
        }))
        this.roomManager.start()

        if (this.room.meta && this.room.meta.wallParams) {
          Object.keys(this.room.meta.wallParams).forEach(k => {
            Vue.set(this.wallParams, k, {loot_item_id: this.room.meta.wallParams[k].loot_item_id})
            this.room.meta.wallParams[k] = Object.assign(this.room.meta.wallParams[k], this.room.meta.wallParams[k].loot_item.meta)
          })
        }

        if (this.room.meta && this.room.meta.floorParams) {
          this.floorParams = {loot_item_id: this.room.meta.floorParams.loot_item_id}
          this.room.meta.floorParams = Object.assign(this.room.meta.floorParams, this.room.meta.floorParams.loot_item.meta)
        }

        await this.roomManager.loadRoom(this.room.meta)

        // let roomObjects = []
        if (response.data.room.item_meta && response.data.room.item_meta.items) {
          // roomObjects = response.data.room.item_meta.items.map(i => this.roomItemToRoomObject(i))
          response.data.room.item_meta.items.forEach(ri => {
            this.addToRoom(ri, ri.loot_item)
          })
        }
        // await this.roomManager.loadRoom(Object.assign({roomObjects: roomObjects}, this.room.meta))

        this.roomManager.gameLoop()

        this.roomDisplayed = this.user.id
      } else {
        console.log('ERROR LOADING ROOM')
      }
      // .render('#paypal-button-container')
    }
  }
}
</script>

<style scoped>
.wall-base-add {
  background-color: rgb(86, 139, 55);
  box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
  user-select: none;
  color:white;
  margin: 5px;
  margin-top: 5px;
  border-radius: 5px;
  border-top: 2px rgb(126, 85, 187) solid;
  padding: 0px 10px;
  cursor: pointer;
  transition: background-color 0.3s;
  height: 40px;
}

.wall-base-remove {
  background-color: rgb(177, 34, 34);
  box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
  user-select: none;
  color:white;
  margin: 5px;
  margin-top: 5px;
  border-radius: 5px;
  border-top: 2px rgb(126, 85, 187) solid;
  padding: 0px 10px;
  cursor: pointer;
  transition: background-color 0.3s;
  height: 40px;
}


.btn-save{
    width:80%;
    display: inline-block;
    border-top: 4px #b62626 solid;
    padding: 5px;
    border-radius: 4px;
    box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
    transition: background-color 0.2s , border-color 0.2s;
    margin: 5px;
    min-width: 50px;
    user-select: none;
    color:white;

    background-color: #5A3E85;
    height: 40px;
    margin-top: 5px;
    border-radius: 5px;
    border-top: 2px rgb(126, 85, 187) solid;
    padding: 0px 10px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.btn-save:hover{
    background-color: #b62626;
    border-top: 4px rgb(255, 0, 0) solid;
}

.btn-copy{
    width:200px;
    display: inline-block;
    border-top: 4px rgb(72, 148, 179) solid;
    padding: 5px;
    border-radius: 4px;
    box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
    transition: background-color 0.2s , border-color 0.2s;
    margin: 5px;
    min-width: 50px;
    user-select: none;
    color:white;

    background-color: rgb(91, 185, 223);
    height: 25px;
    margin-top: 5px;
    border-radius: 5px;
    border-top: 2px rgb(72, 148, 179) solid;
    padding: 0px 10px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.btn-copy:hover{
    background-color: rgb(86, 139, 55);
    border-top: 4px rgb(85, 155, 44) solid;
}
</style>

<style>
  #room-container {
    min-height: 500px;
    outline: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0); /* mobile webkit */
  }

  #room-container canvas {
    outline: none; border: none;

  }

  .upper-right-area {
    /* float:right; */
    /* right:-20; */
    /* position:absolute; */
    text-align:center;
  }

  .room-hello {
    overflow: hidden;
  }

  .btn-enabled{
    display: inline-block;
    border-top: 4px #b62626 solid;
    padding: 5px;
    border-radius: 4px;
    box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
    transition: background-color 0.2s , border-color 0.2s;
    margin: 5px;
    min-width: 50px;
    user-select: none;
    cursor: pointer;
    color:white;
}

.btn-top{
    width:200px;
}
.btn-enabled:hover{
    background-color: #b62626;
    border-top: 4px rgb(255, 0, 0) solid;
}
.btn-selected{
  background-color: #b62626;
    border-top: 4px rgb(255, 0, 0) solid;
}

.cyberpunk-menu {
    background: linear-gradient(90deg, #9a1e1e, #181111); /*linear-gradient(90deg, #ff0000, #000000);*/
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 50px;
    padding-right: 50px;
}

.menu-title {
    font-size: 2rem;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 4px;
    color: #ff00ff;
    text-shadow: 0 0 10px rgba(255, 0, 255, 1), 0 0 20px rgba(255, 0, 255, 0.6);
}

.cyberpunk-menu ul {
    list-style: none;
    display: flex;
    justify-content: center;
    gap: 50px;
}

.cyberpunk-menu ul li {
    position: relative;
}

.menu-button {
    color: #ff0000;
    text-decoration: none;
    font-size: 1.2rem;
    padding: 10px 20px;
    background-color: rgb(177 33 33 / 65%);
    border: 2px solid #ff0000;
    border-radius: 5px;
    transition: all 0.3s ease;
    box-shadow: 0 0 10px rgba(255, 0, 0, 0.8), 0 0 20px rgba(255, 0, 0, 0.6);
    /* background: linear-gradient(45deg, transparent, rgba(255, 0, 0, 0.4), transparent); */
    text-transform: uppercase;
    letter-spacing: 2px;
    position: relative;
    z-index: 1;
}

.menu-button a {
    color: #ffffff;
    text-decoration: none;
}

.menu-button::before {
    content: '';
    position: absolute;
    width:100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, transparent, rgba(255, 0, 0, 0.4), transparent);
    z-index: -1;
    transition: opacity 0.4s ease;
}

.menu-button:hover::before {
    opacity: 1;
}

.menu-button:hover {
    color: #fff;
    background-color: rgba(255, 0, 0, 0.3);
    border-color: #ff3333;
    box-shadow: 0 0 20px rgba(255, 0, 0, 1), 0 0 40px rgba(255, 0, 0, 0.8);
}
</style>


// WEBPACK FOOTER //
// src/components/Rooms.vue